<template lang="html">
  <div class="vid-int-end">
    <img src="/static/images/elements/icon_ok.svg" />
    <div class="vid-int-end-title">
      <div>{{ $tr('onlineInterview.room.finish') }}</div>
      <div>{{ $tr('vacancy.preferences.application.sentApplication') }}</div>
    </div>
    <div class="vid-int-end-note">{{ $tr('interview.tests.end.answersSend') }}</div>
  </div>
</template>

<script>
export default {
  name: 'InterviewEnd',

  props: {
    candidate: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      link: ''
    };
  },

  methods: {
    copyLink() {
      const link = this.$refs.link;
      let rng = document.createRange();
      rng.setStart(link, 0);
      rng.setEnd(link, 1);
      let sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(rng);

      try {
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        this.$noty.success(this.$tr('common.copy_link_success'));
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.vid-int-end {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100px;
  }
}

.vid-int-end-title {
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  text-align: center;
  color: #233346;
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}

.vid-int-end-note {
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  color: #233346;
}

.vid-int-end--videoresume {
  &.vid-int-end {
    text-align: center;

    .vid-int-end-title {
      font-style: normal;
      font-weight: bold;
      font-size: 30px;
      line-height: 36px;
      text-align: center;
      color: #555555;
      margin-bottom: 16px;
    }

    .vid-int-end-note {
      margin-top: 18px;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #c4b9d3;
    }

    .vid-int-end-desc-text {
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 24px;
      text-align: center;
      color: #8d8d8d;
    }

    .vid-int-end-desc-link {
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 28px;
      background: linear-gradient(315.55deg, #848bd3 0%, #bc89e5 100%);
      -webkit-background-clip: text !important;
      -webkit-text-fill-color: transparent !important;
    }

    .vid-int-end-desc-icons {
      margin-left: 14px;
    }
  }
}
</style>
